import { observer } from "mobx-react-lite";
import React from "react";
import "./styles.scss";
import { currencyFormat } from "../../../../../utils/functions";
import AddToCartButton from "../AddToCartButton";

interface ProductCarouselProps {
  product?: any;
}

const ProductCard: React.FC<ProductCarouselProps> = observer(({ product }) => {

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm max-md:p-3">
      <div className="w-full flex">
        <div className="w-full">
          <a className="flex-row-reverse" href={`/produto/${product.slug}`} aria-label={`Ir para o produto: ${product?.name}`}>
            <img width={170} height={170} loading="lazy" className="mx-auto" src={product.files[0]?.path} alt={product.name} />
          </a>
        </div>
      </div>
      <div className="pt-6 flex flex-col justify-between">
        <div>
          <a href={`/produto/${product.slug}`} className="line-clamp-2 min-h-12 text-base font-semibold text-gray-900">{product.name}</a>
        </div>

        <div className="mt-4 flex items-center justify-between max-md:flex-col max-md:mt-2 max-md:gap-2">
          <p className="text-xl font-bold leading-tight text-gray-900 min-w-max max-md:text-base">{product && product.prices && currencyFormat(product?.prices[0]?.price)}</p>

          <div className="max-md:w-full">
            <AddToCartButton
              quantity={1}
              buttonText="Adicionar"
              product={product}
            />
          </div>
        </div>
      </div>
    </div>
  );
});

export default ProductCard;
